import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Coordination Visibility — RETIRED in Iter 59.2 (Alpha Critical Regression).
 *
 * Per the Alpha Readiness directive, executive-tier roll-ups scope-leak PM
 * analytics outside the customer plan-room surface. The /dashboard/executive
 * endpoint now returns 410. This page renders a minimal retirement notice so
 * any saved bookmarks land somewhere informative instead of throwing.
 */
export default function Executive() {
  const [_retired, setRetired] = useState(true);

  useEffect(() => {
    api.get("/dashboard/executive").catch((err) => {
      setRetired(err?.response?.status === 410);
    });
  }, []);

  return (
    <div className="p-8 max-w-[760px] mx-auto" data-testid="executive-page">
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[var(--fop-text-3)] mb-2">
        Coordination Visibility · Retired
      </div>
      <h1 className="font-display text-3xl text-[var(--fop-text)]">
        This view has been retired
      </h1>
      <p className="text-[var(--fop-text-2)] mt-4 text-sm leading-6">
        ForgedOps Plans now scopes coordination signals inside each project and
        sheet, not as a portfolio roll-up. Open a project, then a sheet to see
        hot pins, recent revisions, and stationing context for the work actually
        in the field.
      </p>
      <a
        href="/portfolio"
        className="btn btn-primary mt-6 inline-flex"
        data-testid="executive-retired-portfolio-link"
      >
        Go to Portfolio
      </a>
    </div>
  );
}
